import { axios, API, SendRequest} from '@/imports-files/pages/clients/recruitments/unsuccessful-reasons';

export class UnsuccessfulReasonService extends SendRequest
{
  async getReasonsListData(params)
    {
        const url = API.client.unsuccessful_reasons.REASON_LIST;
        try {
             const result = await axios.get( url,
              {
                params: params,
                headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }

    async createReasonsListData(params)
    {
        const url = API.client.unsuccessful_reasons.CREATE_REASON;
        try {
             const result = await axios.post( url,
              params,
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }

    async deleteReasonsListData(reason_id)
    {
        const url = API.client.unsuccessful_reasons.RUD_REASON.replace('$reason_id', reason_id);
        try {
             const result = await axios.delete( url,
              {
                headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }

    async updateReasonsListData(params, reason_id)
    { 
        const url = API.client.unsuccessful_reasons.RUD_REASON.replace('$reason_id', reason_id);

        try {
             const result = await axios.put( url,
              params,
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }

    async showReasonListData(reason_id)
    {
        const url = API.client.unsuccessful_reasons.RUD_REASON.replace('$reason_id', reason_id);
          try {
              const result = await axios.get( url,
                {
                  headers: this.customHeaderJSON()
                },
                this.setHeaderJSON(),
                this.setCrossDomainTrue(),
                this.setCredentialsJSON());
              return result;
            } catch (error) {
              return error;
            }
    }

} 